import { UserAccessModal } from 'components/UserAccessModal/UserAccessModal';
import { ReactComponent as CheckIcon } from 'icons/check.svg';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isAuthenticated, isPayingFromChina } from 'selectors';
import { useTranslations } from 'utils';
import { createMarkup } from 'utils/createMarkup/createMarkup';

export interface MandatoryAccountModalProps {
  onLoginSuccess?: () => void;
  onSignUpSuccess?: () => void;
  showSignupTab?: boolean;
}

const AdvantagesList = () => {
  const i18n = useTranslations();
  const payingFromChina = useSelector(isPayingFromChina);

  const advantages = [
    payingFromChina
      ? 'userSignup.mandatoryAccount.ch.advantagesOne'
      : 'userSignup.mandatoryAccount.advantagesOne',
    payingFromChina
      ? 'userSignup.mandatoryAccount.ch.advantagesTwo'
      : 'userSignup.mandatoryAccount.advantagesTwo',
    'userSignup.mandatoryAccount.advantagesThree',
  ];

  return (
    <ul
      className="list-none text-sm text-gray-700 space-y-4 p-2"
      data-testid="advantagesList"
    >
      {advantages.map(key => (
        <li key={key} className="flex items-center gap-3">
          <CheckIcon />
          <span dangerouslySetInnerHTML={createMarkup(i18n.t(key))} />
        </li>
      ))}
    </ul>
  );
};

const MandatoryAccountModal = ({
  onLoginSuccess,
  onSignUpSuccess,
  showSignupTab = true,
}: MandatoryAccountModalProps) => {
  const i18n = useTranslations();
  const authenticated = useSelector(isAuthenticated);
  const payingFromChina = useSelector(isPayingFromChina);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!authenticated) {
      setIsModalOpen(true);
    }
  }, [authenticated]);

  const handleLoginSuccess = useCallback(() => {
    setIsModalOpen(false);
    onLoginSuccess?.();
  }, [onLoginSuccess]);

  const handleSignUpSuccess = useCallback(() => {
    setIsModalOpen(false);
    onSignUpSuccess?.();
  }, [onSignUpSuccess]);

  return (
    <UserAccessModal
      isOpen={isModalOpen}
      showSignupTab={showSignupTab}
      allowClosing={false}
      onLoginSuccess={handleLoginSuccess}
      onSignUpSuccess={handleSignUpSuccess}
      headerLogin={
        <h2 className="text-2xl text-gray-950 text-center">
          {i18n.t('userLogin.mandatoryAccount.title')}
        </h2>
      }
      headerSignUp={
        <>
          <h2 className="text-2xl text-gray-950 text-center">
            {i18n.t('userSignup.mandatoryAccount.title')}
          </h2>
          <AdvantagesList />
        </>
      }
      hideSocialLogin={payingFromChina}
    />
  );
};

export { MandatoryAccountModal };
